import { SET_CURRENT_USER, SET_CSRF_TOKEN, SET_PREVIOUS_PATH, SET_UNREAD_EVENTS_COUNT } from '../../constants';

export const setCurrentUser = (currentUser) => ({ type: SET_CURRENT_USER, payload: currentUser });

export const setUnreadEventsCount = (count) => ({ type: SET_UNREAD_EVENTS_COUNT, payload: count });

export const setPreviousPath = (path) => ({ type: SET_PREVIOUS_PATH, payload: path });

export const setCSRFToken = (token) => ({ type: SET_CSRF_TOKEN, payload: token });
